import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import Order from '../../main/order-grid/order';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useTheme, withStyles } from '@material-ui/core/styles';

const styles = theme => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
});

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
    </MuiDialogTitle>
  );
});

function OrderDialog(props) {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('xs'));
  if (!props.order) {
    return null;
  }


  return (
    <Dialog
      fullScreen={fullScreen}
      open={props.open}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">Bestellung</DialogTitle>
      <DialogContent>
        <Order
          value={props.order}
          localSettings={{}}
          proceedOrder={props.proceedOrder}
        />
      </DialogContent>
      <DialogActions>
        <Button color="primary" onClick={props.onClose}>Schließen</Button>
      </DialogActions>
    </Dialog>
  );
}

OrderDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  order: PropTypes.object,
  onClose: PropTypes.func,
};

OrderDialog.defaultProps = {
  order: null,
  onDismiss: () => { },
  onClose: () => { },
};

export default OrderDialog;
